module.exports = __webpack_public_path__ + "static/media/statements-icon.befd61ac.svg";